import * as blockMigrators from './blockMigrators';

export default function migrateBlock(block: any) {
  // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  return blockMigrators[`${block._type}Migrator`](block);
}
